<template>
  <FormContainer @submitForm="saveStatoPatrimoniale">
    <div class="row">
      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6 mb-4"
        label="Mese"
        not-required
        v-model="statoPatrimoniale.month"
        :errorMsg="errorHash['month']"
        @input="removeError('month')"
      />
    </div>

    <BalanceInput v-model="statoPatrimoniale.balance" />

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva Stato Patrimoniale
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    BalanceInput: () => import('./Widgets/BalanceInput'),
  },
  props: {
    statoPatrimoniale: {
      type: Object,
      default: () => ({
        month: null,
        balance: {},
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.statoPatrimoniale.month) {
        this.addError('Il mese è obbligatorio', 'month');
      }

      return !this.hasErrors;
    },
    saveStatoPatrimoniale () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.statoPatrimoniale);
    },
  },
};

</script>
